import LoginHOC from '../components/LoginHOC';
import ErrorBoundary from '../components/ErrorBoundary';
import ViewBuild from '../components/ViewBuild';
import ViewBuilds from '../components/ViewBuilds';
import { useAnalyticsCommand } from '../utilities/useAnalytics';

export default function BuildsCommand({
  id,
  shouldViewLatest,
  configPath = undefined,
  count,
  format = 'table',
  exit,
}: {
  id?: string;
  shouldViewLatest?: boolean;
  configPath?: string;
  count?: number;
  format?: 'table' | 'json';
  exit?: boolean;
}) {
  useAnalyticsCommand('builds', {
    id,
    shouldViewLatest,
    configPath,
    count,
    format,
    exit,
  });

  const getContents = () => {
    let commandUsed = 'todesktop builds';
    if (id) {
      commandUsed += ' <id>';
      return (
        <ViewBuild commandUsed={commandUsed} id={id} configPath={configPath} />
      );
    } else if (shouldViewLatest) {
      commandUsed += ' --latest';
      return (
        <ViewBuild
          commandUsed={commandUsed}
          shouldViewLatest
          configPath={configPath}
        />
      );
    } else {
      return (
        <ViewBuilds
          commandUsed={commandUsed}
          configPath={configPath}
          count={count}
          format={format}
          exit={exit}
        />
      );
    }
  };

  return (
    <ErrorBoundary>
      <LoginHOC>{getContents()}</LoginHOC>
    </ErrorBoundary>
  );
}
